module.exports = __webpack_public_path__ + "img/Promundo.8856877d.svg";